import { Typography } from 'antd';
import dayjs from 'dayjs';
import { DEFAULT_DATE_FORMAT, SECONDS_PATTERN } from '../../../constants/constants';
import { DateFormatEnum } from '../../../constants/fields';
import { convertUtcToLocal } from '../../../utils/utils';
import { DateFieldProps } from '../Fields';
import { parseDateFormats } from '../utils';
import { DateRangeText } from './DateRange';

const { Text } = Typography;
const TEST_DATE = '01/13/2000';

export const DateText = (props: DateFieldProps) => {
	const { dateFormat, fieldValue, timeZoneOffsetMins } = props;
	if (!(typeof fieldValue === 'number') && !fieldValue) {
		return null;
	}
	const isDateRangeField = dateFormat === DateFormatEnum.DateRange;
	if (isDateRangeField) {
		return <DateRangeText {...props} />;
	}
	const offsetFromUTCLocal = dayjs(Number(fieldValue) * 1000).utcOffset();

	const dateValue = convertUtcToLocal(
		(Number(fieldValue) - offsetFromUTCLocal * 60) * 1000,
		timeZoneOffsetMins
	);

	const fetchFormat = () => {
		const initialFormat = parseDateFormats(
			dateFormat ?? DEFAULT_DATE_FORMAT,
			SECONDS_PATTERN,
			true
		);
		const formattedDateString = dayjs(new Date(TEST_DATE)).format(initialFormat);
		const parsedDate = dayjs(formattedDateString, initialFormat, true);
		return parsedDate.isValid() ? initialFormat : DEFAULT_DATE_FORMAT;
	};

	const formattedDate = dayjs(dateValue).format(fetchFormat());

	return <Text>{formattedDate}</Text>;
};
